/**
 * Created on 2018/10/25.
 */
function padLeftZero(str) {
    return ('00' + str).substr(str.length)
}

/**
 * 对Date的扩展，将 Date 转化为指定格式的String
 * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q) 可以用 1-2 个占位符
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * eg:
 * (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * (new Date()).Format("yyyy-MM-dd E HH:mm:ss") ==> 2009-03-10 二 20:09:04
 * (new Date()).Format("yyyy-MM-dd EE hh:mm:ss") ==> 2009-03-10 周二 08:09:04
 * (new Date()).Format("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
 * (new Date()).Format("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
 */
Date.prototype.Format = function(fmt) {
    var o = {
        'M+': this.getMonth() + 1, //月份
        'd+': this.getDate(), //日
        'h+': this.getHours(), //小时
        'm+': this.getMinutes(), //分
        's+': this.getSeconds(), //秒
        'q+': Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds() //毫秒
    }
    var week = {
        '0': '\u65e5',
        '1': '\u4e00',
        '2': '\u4e8c',
        '3': '\u4e09',
        '4': '\u56db',
        '5': '\u4e94',
        '6': '\u516d'
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
    }
    if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (RegExp.$1.length > 1
                ? RegExp.$1.length > 2
                    ? '\u661f\u671f'
                    : '\u5468'
                : '') + week[this.getDay() + '']
        )
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                    ? o[k]
                    : ('00' + o[k]).substr(('' + o[k]).length)
            )
        }
    }
    return fmt
}

import moment from "moment-timezone";

export default {
    formatDate(date, fmt) {
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                (date.getFullYear() + "").substr(4 - RegExp.$1.length),
            );
        }
        let o = {
            "M+": date.getMonth() + 1,
            "d+": date.getDate(),
            "h+": date.getHours(),
            "m+": date.getMinutes(),
            "s+": date.getSeconds(),
        };
        for (let k in o) {
            if (new RegExp(`(${k})`).test(fmt)) {
                let str = o[k] + "";
                fmt = fmt.replace(
                    RegExp.$1,
                    RegExp.$1.length === 1 ? str : padLeftZero(str),
                );
            }
        }
        return fmt;
    },

    // 转化为千分符
    numFormat(value) {
        if (!value) return "0.00";

        var intPart = Math.floor(Number(value)); //获取整数部分
        var intPartFormat = intPart
            .toString()
            .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); //将整数部分逢三一断
        // 预定义小数部分
        // var floatPart = ".00";

        var value2Array = value.toString().split(".");

        //=2表示数据有小数位
        if (value2Array.length == 2) {
            var floatPart = value2Array[1]; //拿到小数部分

            if (floatPart.length == 1) {
                //补0,实际上用不着
                return intPartFormat + "." + floatPart + "0";
            } else {
                return intPartFormat + "." + floatPart;
            }
        } else {
            return intPartFormat;
        }
    },

    // 比较日期大小
    dateAround(date1, date2) {
        if (date1 && date2) {
            var oDate1 = new Date(date1);
            var oDate2 = new Date(date2);

            if (oDate1.getTime() > oDate2.getTime()) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    },

    /**
     * 返回指定日期的下一天,
     * @param {string} date 日期
     * @int {string} num 相隔几天
     */
    getNextDay(date, num) {
        let theDay = new Date(date);
        theDay = +theDay + 1000 * 60 * 60 * 24 * num;
        theDay = new Date(theDay);

        let year = theDay.getFullYear();
        let month = theDay.getMonth() + 1;
        let day = theDay.getDate();

        if (month < 10) {
            month = "0" + month;
        }

        if (day < 10) {
            day = "0" + day;
        }

        //格式化
        return year + "-" + month + "-" + day;
    },

    /**
     * 返回指定格式的当前时间日期
     * @param  {string} fmt 日期格式，如'yyyy-MM-dd'
     * @return {string}     指定格式的时间日期
     */
    getCurrentDateWithFormat(fmt) {
        var today = new Date();
        return today.Format(fmt);
    },

    //计算天数差的函数，通用
    dateDiff(sDate1, sDate2) {
        let aDate, oDate1, oDate2, iDays, type;

        if (sDate1.indexOf("-") != -1) {
            type = "-";
        } else {
            type = ".";
        }
        aDate = sDate1.split(type);
        oDate1 = new Date(aDate[0] + "-" + aDate[1] + "-" + aDate[2]);
        aDate = sDate2.split(type);
        oDate2 = new Date(aDate[0] + "-" + aDate[1] + "-" + aDate[2]);
        iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24);
        return iDays;
    },

    // 去重
    unique(arr) {
        let res = [];

        for (var i = 0; i < arr.length; i++) {
            if (arr.indexOf(arr[i]) == i) {
                // 如果res新数组包含当前循环item
                res.push(arr[i]);
            }
        }

        return res;
    },

    // 时间格式化
    formatDateTime(time, type) {
        let date = new Date(time),
            dateType = 'YYYY/MM/DD HH:mm:ss'

        switch (type) {
            case "date":
                dateType = 'YYYY/MM/DD'
                break;
            case "min":
                dateType = 'YYYY/MM/DD HH:mm'
                break;
            default:
                break;
        }

        return moment(date).format(dateType);
    },
};



// WEBPACK FOOTER //
// ./src/common/date.js